import { FC } from 'react';

import {
    Bot,
    ChevronDown,
    ChevronUp,
    ExternalLink,
    Send,
} from 'lucide-react';

import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from '../../components/ui/Card';

export type TelegramBotAccount = {
    username?: string | null;
    connected_at: string;
};

export type TelegramBotSettingsData = {
    account: TelegramBotAccount | null;
    connect_url?: string | null;
};

interface Props {
    settings?: TelegramBotSettingsData;
    isOpen: boolean;
    onToggle: () => void;
}

export const TelegramBotSettings: FC<Props> = ({
    settings,
    isOpen,
    onToggle,
}) => {
    const account = settings?.account ?? null;
    const isConnected = Boolean(account);
    const connectUrl = settings?.connect_url;

    return (
        <Card className="h-fit">
            <CardHeader
                className="cursor-pointer transition-colors hover:bg-muted/50"
                onClick={onToggle}
            >
                <CardTitle className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <Bot className="h-5 w-5 text-primary" />
                        Налаштування Telegram Bot
                    </div>
                    {isOpen ? (
                        <ChevronUp className="h-4 w-4 text-muted-foreground" />
                    ) : (
                        <ChevronDown className="h-4 w-4 text-muted-foreground" />
                    )}
                </CardTitle>
                <CardDescription>
                    Підключіть Telegram-бота, щоб отримувати повідомлення від
                    CartOn у Telegram
                </CardDescription>
            </CardHeader>
            {isOpen && (
                <CardContent className="space-y-4">
                    <div className="flex flex-col gap-3 rounded-xl border bg-muted/20 p-4 sm:flex-row sm:items-center sm:justify-between">
                        <div className="space-y-2">
                            <div className="flex items-center gap-2">
                                <span className="text-sm font-medium">
                                    Статус підключення
                                </span>
                                <Badge
                                    variant={
                                        isConnected ? 'success' : 'secondary'
                                    }
                                >
                                    {isConnected
                                        ? 'Підключено'
                                        : 'Не підключено'}
                                </Badge>
                            </div>
                            <p className="text-sm text-muted-foreground">
                                {isConnected
                                    ? `Telegram акаунт ${account?.username ? `@${account.username}` : ''} привʼязаний до профілю.`
                                    : 'Щоб увімкнути Telegram-нотифікації, спочатку підключіть бота.'}
                            </p>
                        </div>

                        {!isConnected && (
                            <Button asChild disabled={!connectUrl}>
                                <a
                                    href={connectUrl ?? '#'}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <Send className="mr-2 h-4 w-4" />
                                    Підключити
                                    <ExternalLink className="ml-2 h-4 w-4" />
                                </a>
                            </Button>
                        )}
                    </div>

                    {isConnected && (
                        <p className="text-sm text-muted-foreground">
                            Типи сповіщень налаштовуються в окремому блоці
                            “Налаштування сповіщень”.
                        </p>
                    )}
                </CardContent>
            )}
        </Card>
    );
};
